import api from '@/api';

const getters = {
  organizations: state => state.organizations,
  organizationId: state => {
    if (state.organizations && state.organizations.length === 1) {
      return state.organizations[0].id;
    }
    return state.organizationId;
  },
  organizationOverview: state => state.organizationOverview,
  organizationProficiency: state => state.organizationProficiency,
  organizationLevels: state => state.organizationLevels,
};

export const mutations = {
  SET_ORGANIZATIONS(state, { organizations }) {
    state.organizations = organizations.slice().sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  },
  SET_ORGANIZATION_ID(state, { organizationId }) {
    state.organizationId = organizationId;
  },
  SET_ORGANIZATION_LEVELS(state, { levels }) {
    state.organizationLevels = levels;
  },
};

export const actions = {
  FETCH_ORGANIZATIONS: ({ commit, state, rootGetters }) => {
    return new Promise(resolve => {
      if (state.organizations.length) return resolve(state.organizations);

      return api.fetchOrganizations().then((organizations = []) => {
        commit('SET_ORGANIZATIONS', { organizations });

        let organizationIdIsSet = !!state.organizationId;
        const organizationIds = state.organizations.map(organization => organization.id);

        if (organizationIdIsSet && !organizationIds.includes(state.organizationId)) {
          organizationIdIsSet = false;
        }

        if (!organizationIdIsSet) {
          if (organizations.length > 0) {
            commit('SET_ORGANIZATION_ID', { organizationId: organizations[0].id });
          } else {
            const { organization } = rootGetters.userProfile;

            if (organization) {
              commit('SET_ORGANIZATION_ID', { organizationId: organization.id });
            }
          }
        }

        resolve(organizations);
      });
    });
  },

  FETCH_ORGANIZATION_LEVELS: ({ commit, state }) => {
    return new Promise(resolve => {
      api.fetchOrganizationLevels(state.organizationId).then(levels => {
        commit('SET_ORGANIZATION_LEVELS', { levels });
        resolve(levels);
      });
    });
  },

  FETCH_ORGANIZATION_CUSTOMER_PACKAGES: async ({ dispatch, state }) => {
    dispatch('wait/start', 'organizations.fetchCustomerPackages', { root: true });

    try {
      return await api.fetchOrganizationCustomerPackages(state.organizationId);
    } finally {
      dispatch('wait/end', 'organizations.fetchCustomerPackages', { root: true });
    }
  },
};

const state = {
  organizations: [],
  organizationId: null,
  organizationLevels: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
